<template>
  <div class="ExpertHubProfileCard">
    <el-card class="expert-detail-card">
      <div class="profile-section text-center" @click="goToExpertStore">
        <div class="relative">
          <img :src="serverHostName + user_details.profile_pic" v-if="user_details.profile_pic" class="profile-pic" />

          <img src="../assets/images/navBar/avatar.jpg" v-else class="profile-pic" />

          <!-- <div class="rank-wrapper" v-if="user_details.rank">
                        <Hexagon :rank="user_details.rank"></Hexagon>
                    </div> -->
        </div>

        <div class="profile-details-section">
          <div class="title capitalize ellipsis" style="margin: 10px auto 0 auto;" :title="user_details.name">
            {{ user_details.name }}
          </div>
          <div class="input-label-gray top-margin-5" v-if="user_details.profession == 'Analyst' ||
            user_details.profession == 'Financial Advisor'
            ">
            {{ user_details.profession }}
          </div>
          <div class="input-label-gray top-margin-5" v-else>
            &nbsp;
          </div>

          <div class="input-label-gray ellipsis" style="margin: 0 auto;" :title="user_details.company"
            v-if="user_details.profession != 'Student'">
            {{ user_details.company }}
          </div>

          <div class="input-label-gray" v-if="user_details.profession != 'Student' && !user_details.company">
            &nbsp;
          </div>

          <div class="input-label-gray ellipsis" style="margin: 0 auto;" :title="userProfile.institute_name" v-if="user_details.profession == 'Student' &&
            user_details.institute_name
            ">
            {{ userProfile.institute_name }}
          </div>

          <div class="input-label-gray ellipsis" style="margin: 0 auto;" v-if="user_details.profession == 'Student' &&
            !user_details.institute_name
            ">
            &nbsp;
          </div>

          <div class="text-center">
            <el-tooltip v-if="user_details.mark_as_verified" class="item" effect="dark"
              content="Verified SEBI registered Expert" placement="top">
              <img class="info-Logo cursor-pointer" src="../assets/images/verify.svg" style="width: 16px;" alt />
            </el-tooltip>
            <span v-else>&nbsp;</span>
          </div>
          <div class="text-center ">

            <el-tooltip v-if="user_details.is_public" class="item" effect="dark" content="Public profile" placement="top">
              <span class="left-margin-10"><img src="../assets/images/expertHub/published.png" class="cursor-pointer"
                  width="14" /></span>
            </el-tooltip>

            <span v-else>&nbsp;</span>
          </div>



          <div>
            <div class="more-details-section top-margin-10">
              <div v-if="user_details.annualised_roi" style="width: 100px;">
                <div class="label-xs-bold" style="font-weight: 600;">
                  {{
                    active_period == '1Y'
                    ? user_details.annualised_roi + "%"
                    : user_details.absolute_roi + '%'
                  }}
                </div>
                <span class="input-label-bold-gray" style="font-size: 11px;">
                  {{ active_period == '1Y'
                    ? 'Annualised ROI'
                    : ' Avg ROI'
                  }}

                </span>
              </div>

              <div style="width: 100px;">
                <div class="label-xs-bold" style="font-weight: 600;">
                  {{
                    user_details.success_rate ? user_details.success_rate : 0
                  }}%
                </div>
                <span class="input-label-bold-gray" style="font-size: 11px;">Success Rate</span>
              </div>
            </div>

            <div class="more-details-section top-margin-10">
              <div style="width: 100px;">
                <div class="label-xs-bold primary-theme-color" style="font-weight: 600;">
                  {{ user_details.live_reco ? user_details.live_reco : 0 }}
                </div>
                <span class="input-label-bold-gray" style="font-size: 11px;">Live Reco
                </span>
              </div>
              <div style="width: 100px;">
                <div class="label-xs-bold" style="font-weight: 600;">
                  {{ user_details.total_reco ? user_details.total_reco : 0 }}
                </div>
                <span class="input-label-bold-gray" style="font-size: 11px;">Total Reco</span>
              </div>
            </div>

          </div>
        </div>
      </div>

    </el-card>
  </div>
</template>
<script>
import { serverHostName } from "../networkConfig";
import Hexagon from "@/components/Hexagon.vue";

export default {
  name: "ExpertHubProfileCard",

  props: ["user_details", "display_profile_verified_icons", 'period_filter', 'active_period'],

  components: {
    Hexagon,
  },

  data() {
    return {
      serverHostName: serverHostName,
    };
  },

  methods: {
    goToExpertStore(e) {
      if (e.target.className == "follow-btn") {
        this.$emit("followExpert");
        return;
      }
      this.$store.commit("selectActivePeriod", this.active_period);
      this.$emit("goToExpertStore");
    },
  },

  computed: {
    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.ExpertHubProfileCard {
  .expert-detail-card {
    margin: 15px 0px;
    border-radius: 9px;
  }

  .profile-section {
    padding: 20px;
    height: 265px;
  }

  .profile-pic {
    height: 60px;
    width: 60px;
    object-fit: cover;
    border-radius: 100%;
  }

  .rank-wrapper {
    position: absolute;
    bottom: -8px;
    right: 0;
    left: 0;
  }

  .profile-details-section {
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #000;
    }
  }

  .performer-rating {
    i {
      font-size: 1rem;
      color: #ffcc00;
    }
  }

  .portfolio-rating {
    i {
      font-size: 1rem;
      color: #1870cb;
      // color: $secondary-theme-color;
    }
  }

  .more-details-section {
    display: flex;
    justify-content: space-around;
  }

  .bottom {
    background: #eceff4;
    padding: 10px;
    text-align: center;
  }

  .follow-btn {
    background: transparent;
    color: $primary-theme-color;
    border: 1px solid $primary-theme-color;
    border-radius: 25px;
    width: 80px;
    height: 12px;
    padding: 2px;
    font-size: 0.6rem;
    font-weight: 600;
    margin: 0 auto;
    cursor: pointer;
    // line-height: 0.5;
  }

  .follow-btn:hover {
    background: $primary-theme-color;
    color: #fff;
    border-color: $primary-theme-color;
  }
}
</style>
<style lang="scss">
@import "../css/variable.scss";
@import "../css/common.scss";

.ExpertHubProfileCard {
  .el-card__body {
    padding: 0px;
  }
}
</style>
